export class ListGcpFoldersResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "folders",
            "baseName": "folders",
            "type": "Array<GcpOrganization>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGcpFoldersResponse.attributeTypeMap;
    }
    constructor() {
    }
}
